import { CompanyEntry } from '@dreryk/egabinet-invoice-frontend-api';

type CompanyNameVisitorOptions = {
   companyName: CompanyEntry | string | undefined;
   companyEntries: CompanyEntry[] | undefined;
};

type CompanyNameVisitor = <ACCEPT>(visitor: {
   visitCompanyName: () => ACCEPT;
   visitCompanyEntries: (companyEntries: CompanyEntry[] | undefined) => ACCEPT;
}) => ACCEPT;

export const companyNameVisitor = (options: CompanyNameVisitorOptions): CompanyNameVisitor => (visitor) => {
   if (!options.companyName || typeof options.companyName === 'string') {
      return visitor.visitCompanyName();
   }

   return visitor.visitCompanyEntries(options.companyEntries);
};
